import SwitchDiscountType from '@/components/SwitchDiscountType.vue';

export const TOGGLE_WELCOME_BONUS = 'welcomeBonusEnabled';
export const TOGGLE_BIRTHDAY_BONUS = 'birthdayBonusEnabled';
export const TOGGLE_LIMIT_PERCENT = 'paymentLimitPercentEnable';
/**
 * @description Тип карты лояльности - "Скидочная".
 * @type {string}
 */
export const CARD_TYPE_DISCOUNT = 'discount-type';
/**
 * @description Тип карты лояльности - "Бонусная".
 * @type {string}
 */
export const CARD_TYPE_BONUS = 'bonus-type';
/**
 * @description Режим работы системы лояльности - "Скидочный режим".
 * @type {string}
 */
export const LOYALTY_MODE_DISCOUNT = 'discount-system';
/**
 * @description Режим работы системы лояльности - "Бонусный режим".
 * @type {string}
 */
export const LOYALTY_MODE_BONUS = 'bonus-system';

/**
 * @description Бонусы
 * @param amount
 * @constructor
 */
export function Bonuses(amount) {
  this.amount = amount;

  /**
   * @description К рублям
   * @returns {Number}
   */
  this.toRubles = () => amount * 100;
}

/**
 * @description Режим системы лояльности организации
 * @constructor
 */
export function OrganizationLoyaltySystemSettings(mode = '') {
  this.mode = mode;

  /**
   * @description Получить название режима работы системы лояльности
   * @returns {string}
   */
  this.getModeName = () => {
    switch (this.mode) {
      case LOYALTY_MODE_DISCOUNT:
        return 'Скидочная система';
      case LOYALTY_MODE_BONUS:
        return 'Бонусная система';
      default:
        return 'Неизвестный режим';
    }
  };

  let start = JSON.stringify(this);
  this.refresh = () => {
    start = JSON.stringify(this);
  };
  this.isChanged = () => JSON.stringify(this) !== start;
}

/**
 * @description Правило дискаунт карты
 * @param {string} id
 * @param {string} tmpId
 * @param {number} amount
 * @param {number} percentage
 * @constructor
 */
export function Level(id = '', tmpId = '', amount = 0, percentage = 0) {
  this.id = id;
  this.amount = amount;
  this.percentage = percentage;
  this.tmpId = tmpId;

  this.getId = () => (this.id !== '' ? this.id : this.tmpId);
}

/**
 * @description Настройка скидочной системы
 * @param {Array<Level>} levels
 * @param {Boolean} isMainBranch
 * @constructor
 */
export function DiscountSettings(levels = [], isMainBranch = false) {
  this.level = levels;
  this.isMainBranch = isMainBranch;

  this.addNewLevel = () => {
    const newRule = new Level('', Date.now()
      .toString(), 0, 0);
    this.level.push(newRule);
  };

  this.getLevel = (id) => this.level.find((el) => el.id === id || el.tmpId === id);

  this.deleteLevel = (tmpId) => {
    const index = this.level.findIndex((el) => el.tmpId === tmpId);
    this.level.splice(index, 1);
  };

  this.updateLevel = (newLevel) => {
    const index = this
      .level
      .findIndex((el) => el.id === newLevel.id && el.tmpId === newLevel.tmpId);
    this.level.splice(index, 1, newLevel);
  };

  let start = JSON.stringify(this);
  this.refresh = () => {
    start = JSON.stringify(this);
  };
  /**
   * @description Вернуть предыдущие значения
   * @returns {DiscountSettings}
   */
  this.toPrevious = () => {
    const extracted = JSON.parse(start);
    const preparedLevels = extracted.level.map((level) => new Level(
      level.id,
      level.tmpId,
      level.amount,
      level.percentage,
    ));
    return new DiscountSettings(preparedLevels, extracted.isMainBranch);
  };
  this.isChanged = () => JSON.stringify(this) !== start;
}

/**
 * @description Настройки бонусной системы организации
 * @param {Boolean} lifetimeBonusEnable
 * @param {String} lifetimeBonusDays
 * @param {Boolean} welcomeBonusEnabled
 * @param {Bonuses} welcomeBonusAmount
 * @param {Boolean} birthdayBonusEnabled
 * @param {Bonuses} birthdayBonusAmount
 * @param {Boolean} paymentLimitPercentEnable
 * @param {Number} paymentLimitPercent
 * @param {Boolean} accrueOnBonusPayment
 * @param {Number} accrualBonusPercent
 * @constructor
 */
export function OrganizationBonusSettings(
  lifetimeBonusEnable = false,
  lifetimeBonusDays = '',
  welcomeBonusEnabled = false,
  welcomeBonusAmount = new Bonuses(0),
  birthdayBonusEnabled = false,
  birthdayBonusAmount = new Bonuses(0),
  paymentLimitPercentEnable = false,
  paymentLimitPercent = 0,
  accrueOnBonusPayment = false,
  accrualBonusPercent = 5,
) {
  this.lifetimeBonusEnable = lifetimeBonusEnable;
  this.lifetimeBonusDays = lifetimeBonusDays;
  this.welcomeBonusEnabled = welcomeBonusEnabled;
  this.welcomeBonusAmount = welcomeBonusAmount;
  this.birthdayBonusEnabled = birthdayBonusEnabled;
  this.birthdayBonusAmount = birthdayBonusAmount;
  this.paymentLimitPercentEnable = paymentLimitPercentEnable;
  this.paymentLimitPercent = paymentLimitPercent;
  this.accrueOnBonusPayment = accrueOnBonusPayment;
  this.accrualBonusPercent = accrualBonusPercent;

  /**
   * @description Обработать сброс значения
   * @param {string} fieldName - имя поля галочки
   */
  this.handleToggle = (fieldName) => {
    switch (fieldName) {
      case TOGGLE_WELCOME_BONUS:
        if (!this.welcomeBonusEnabled) {
          this.welcomeBonusAmount = new Bonuses(0);
        }
        break;
      case TOGGLE_BIRTHDAY_BONUS:
        if (!this.birthdayBonusEnabled) {
          this.birthdayBonusAmount = new Bonuses(0);
        }
        break;
      case TOGGLE_LIMIT_PERCENT:
        if (!this.paymentLimitPercentEnable) {
          this.paymentLimitPercent = 0;
        }
        break;
      default:
        break;
    }
  };
}

/**
 * @description Настройки бонусной системы клиники
 * @param {Array<number>} excludedRedemptionServiceIds
 * @param {Array<number>} excludedAccrualServiceIds
 * @constructor
 */
export function ClinicBonusSettings(
  excludedRedemptionServiceIds = [],
  excludedAccrualServiceIds = [],
) {
  this.excludedRedemptionServiceIds = excludedRedemptionServiceIds;
  this.excludedAccrualServiceIds = excludedAccrualServiceIds;
}

/**
 * @description Настройки бонусной системы
 * @param {Boolean} isMainBranch
 * @param {OrganizationBonusSettings} organizationBonusSettings
 * @param {ClinicBonusSettings} clinicBonusSettings
 * @constructor
 */
export function BonusSettings(isMainBranch, organizationBonusSettings, clinicBonusSettings) {
  this.isMainBranch = isMainBranch;
  this.organizationBonusSettings = organizationBonusSettings;
  this.clinicBonusSettings = clinicBonusSettings;
  let start = JSON.stringify(this);
  /**
   * @description Вернуть предыдущие значения
   * @returns {BonusSettings}
   */
  this.toPrevious = () => {
    const extract = JSON.parse(start);
    const organizationSettings = new OrganizationBonusSettings(
      extract.organizationBonusSettings.lifetimeBonusEnable,
      extract.organizationBonusSettings.lifetimeBonusDays,
      extract.organizationBonusSettings.welcomeBonusEnabled,
      new Bonuses(extract.organizationBonusSettings.welcomeBonusAmount.amount),
      extract.organizationBonusSettings.birthdayBonusEnabled,
      new Bonuses(extract.organizationBonusSettings.birthdayBonusAmount.amount),
      extract.organizationBonusSettings.paymentLimitPercentEnable,
      extract.organizationBonusSettings.paymentLimitPercent,
      extract.organizationBonusSettings.accrueOnBonusPayment,
      extract.organizationBonusSettings.accrualBonusPercent,
    );
    const clinicSettings = new ClinicBonusSettings(
      extract.clinicBonusSettings.excludedRedemptionServiceIds,
      extract.clinicBonusSettings.excludedAccrualServiceIds,
    );
    return new BonusSettings(
      extract.isMainBranch,
      organizationSettings,
      clinicSettings,
    );
  };
  this.refresh = () => {
    start = JSON.stringify(this);
  };
  this.isChanged = () => JSON.stringify(this) !== start;
}

/**
 * @description Уровень скидки
 * @param thresholdAmount {string}
 * @param discountPercent {number}
 * @constructor
 */
export function DiscountLevel(thresholdAmount = 0, discountPercent = 0) {
  this.thresholdAmount = thresholdAmount;
  this.discountPercent = discountPercent;

  /**
   * @description Разрешить скидку.
   * @param {string} typeDiscount
   * @param {number} sum
   * @param {number} count
   * @returns {number}
   */
  this.resolveDiscount = (typeDiscount, sum, count = 1) => {
    if (!Number.isFinite(sum) || !Number.isFinite(count) || count <= 0) {
      return 0;
    }
    const fullPrice = sum * count;
    switch (typeDiscount) {
      case SwitchDiscountType.discountInKopeck:
        return Math.round(((fullPrice * this.discountPercent) / 10000)) * 100;
      case SwitchDiscountType.discountInPercent:
        return this.discountPercent;
      default:
        return 0;
    }
  };

  /**
   * @description Получить процент скидки
   * @returns {number}
   */
  this.getDiscountPercent = () => this.discountPercent ?? 0;
}

/**
 * @description Карта лояльности пациента
 * @param number
 * @param patientId
 * @param type
 * @param typeName
 * @param isCreated
 * @constructor
 */
export function PatientLoyaltyCard(
  number = '0',
  patientId = 0,
  type = '',
  typeName = '',
  isCreated = false,
) {
  this.number = number;
  this.patientId = patientId;
  this.type = type;
  this.typeName = typeName;
  this.isCreated = isCreated;

  /**
   * @description Тип бонусная карта
   * @returns {boolean}
   */
  this.isTypeBonusCard = () => this.type === CARD_TYPE_BONUS;

  /**
   * @description Тип скидочная ката
   * @returns {boolean}
   */
  this.isTypeDiscountCard = () => this.type === CARD_TYPE_DISCOUNT;
}

/**
 * @description Бонусная карта
 * @param {String} number
 * @param {Number} patientId
 * @param {Number} amount
 * @param {String} type
 * @param {String} typeName
 * @param {Boolean} isCreated
 * @constructor
 */
export function BonusCard(
  number = '0',
  patientId = 0,
  amount = 0,
  type = '',
  typeName = '',
  isCreated = false,
) {
  PatientLoyaltyCard.call(this, number, patientId, type, typeName, isCreated);
  this.amount = amount;

  /**
   * @description Получить бонусы в рублях
   * @returns {number}
   */
  this.getBonusesInRubles = () => this.amount * 100;
}

/**
 * @description Скидочная карта
 * @param {String} number
 * @param {Number} patientId
 * @param {DiscountLevel} level
 * @param {String} type
 * @param {String} typeName
 * @param {Boolean} isCreated
 * @constructor
 */
export function DiscountCard(
  number = '0',
  patientId = 0,
  level = null,
  type = '',
  typeName = '',
  isCreated = false,
) {
  PatientLoyaltyCard.call(this, number, patientId, type, typeName, isCreated);
  this.level = level;

  /**
   * @description Получить уровень
   * @returns {DiscountLevel}
   */
  this.getDiscountLevel = () => this.level;

  /**
   * @description Есть ли уровень
   * @returns {boolean}
   */
  this.hasLevel = () => this.level !== null;
}

/**
 * @description Транзакция
 * @param id {number}
 * @param createdAt {string}
 * @param amount {number}
 * @param sourceType {string}
 * @constructor
 */
export function Transaction(id, createdAt, amount, sourceType) {
  this.id = id;
  this.createdAt = createdAt;
  this.amount = amount;
  this.sourceType = sourceType;
}

/**
 * @description Детализированная бонусная карта
 * @param number {number}
 * @param transactions {Array<Transaction>}
 * @constructor
 */
export function DetailBonusCard(number, transactions) {
  this.number = number;
  this.transactions = transactions;

  this.getBonusCardName = () => `Бонусная карта № ${this.number}`;
}

/**
 * @description Детализированная скидочная карта
 * @param {number|string} number
 * @param {number} currentDiscountPercent
 * @param {number} amountToNextLevel
 * @constructor
 */
export function DetailDiscountCard(number = 0, currentDiscountPercent = 0, amountToNextLevel = 0) {
  this.number = number;
  this.currentDiscountPercent = currentDiscountPercent;
  this.amountToNextLevel = amountToNextLevel;

  /**
   * @description Получить название скидочной карты
   * @returns {string}
   */
  this.getDiscountCardName = () => `Дисконтная карта № ${this.number}`;

  /**
   * @description Текущий процент скидки
   * @returns {number}
   */
  this.getCurrentDiscountPercent = () => this.currentDiscountPercent ?? 0;

  /**
   * @description Сумма до следующего уровня
   * @returns {number}
   */
  this.getAmountToNextLevel = () => this.amountToNextLevel ?? 0;
}

export default {
  data() {
    return {
      /**
       * @description Детализированная бонусная карта
       * @type {DetailBonusCard|null}
       */
      detailedBonusCard: null,
      /**
       * @description Детализированная скидочная карта
       * @type {DetailDiscountCard|null}
       */
      detailedDiscountCard: null,
      /**
       * @description Показывать ли сайд-бар детализации бонусов
       * @type {Boolean}
       */
      isShowDetailedBonusCard: false,
      /**
       * @description Показывать ли сайд-бар детализации скидочной карты
       * @type {Boolean}
       */
      isShowDetailedDiscountCard: false,
      /**
       * @description Карта лояльности пациента
       * @type {PatientLoyaltyCard|null}
       */
      patientLoyaltyCard: null,
      /**
       * @description Показывать ли модальное окно создания бонусной карты
       * @type {Boolean}
       */
      isShowCreateBonusCardModal: false,
      /**
       * @description Показывать ли модальное окно создания скидочной карты
       * @type {Boolean}
       */
      isShowCreateDiscountCardModal: false,
    };
  },
  methods: {
    /**
     * @description Просмотреть карту лояльности пациента
     * @param patientId
     */
    viewPatientLoyaltyCard(patientId) {
      const onSuccess = ({ card }) => {
        this.patientLoyaltyCard = card;
      };
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      this
        .$loyaltySystemGateway
        .viewPatientLoyaltyCard(patientId)
        .then((either) => {
          either.fold(onFail, onSuccess);
        });
    },
    /**
     * @description Обработать открытие сайд-бара детализации карты.
     * @returns {Promise<void>}
     */
    async onOpenDetailedBonusCard() {
      await this.viewDetailedBonusCard();
      this.isShowDetailedBonusCard = true;
    },
    /**
     * @description Обработать закрытие сайд-бара детализации карты.
     * @returns {void}
     */
    onCloseDetailedBonusCard() {
      this.isShowDetailedBonusCard = false;
    },
    /**
     * @description Обработать открытие сайд-бара детализации скидочной карты.
     * @returns {Promise<void>}
     */
    async onOpenDetailedDiscountCard() {
      await this.viewDetailedDiscountCard();
      this.isShowDetailedDiscountCard = true;
    },
    /**
     * @description Обработать закрытие сайд-бара детализации скидочной карты.
     * @returns {void}
     */
    onCloseDetailedDiscountCard() {
      this.isShowDetailedDiscountCard = false;
    },
    /**
     * @description Просмотреть детализацию бонусной карты пациента
     * @returns {void}
     */
    async viewDetailedBonusCard() {
      const onSuccess = (detailedBonusCard) => {
        this.detailedBonusCard = detailedBonusCard;
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      await this
        .$loyaltySystemGateway
        .viewDetailBonusCard(this.patientLoyaltyCard.patientId)
        .then((either) => {
          either.fold(onFail, onSuccess);
        });
    },
    /**
     * @description Просмотреть детализацию скидочной карты пациента
     * @returns {void}
     */
    async viewDetailedDiscountCard() {
      const onSuccess = (detailedDiscountCard) => {
        this.detailedDiscountCard = detailedDiscountCard;
      };
      const onFail = (error) => {
        this.notifyFail(error.getTitle());
      };
      await this
        .$loyaltySystemGateway
        .viewDetailDiscountCard(this.patientLoyaltyCard.patientId)
        .then((either) => {
          either.fold(onFail, onSuccess);
        });
    },
    /**
     * @description Обработать событие открытия модального окна создания бонусной карты.
     * @returns {void}
     */
    onOpenCreateBonusCardModal() {
      this.isShowCreateBonusCardModal = true;
    },
    /**
     * @description Обработать событие открытия модального окна создания скидочной карты.
     * @returns {void}
     */
    onOpenCreateDiscountCardModal() {
      this.isShowCreateDiscountCardModal = true;
    },
    /**
     * @description Обработать событие закрытия модального окна создания бонусной карты.
     * @returns {void}
     */
    onCloseCreateBonusCardModal() {
      this.isShowCreateBonusCardModal = false;
    },
    /**
     * @description Обработать событие закрытия модального окна создания скидочной карты.
     * @returns {void}
     */
    onCloseCreateDiscountCardModal() {
      this.isShowCreateDiscountCardModal = false;
    },
    /**
     * @description Обработать событие создания бонусной краты
     * @returns {void}
     */
    onSubmitBonusCard() {
      this.createBonusCard();
    },
    /**
     * @description Обработать событие создания скидочной краты
     * @returns {void}
     */
    onSubmitDiscountCard() {
      this.createDiscountCard();
    },
    /**
     * @description Создать бонусную карту
     * @returns {void}
     */
    createBonusCard() {
      const onSuccess = ({ title }) => {
        this.notifySuccess(title);
        this.viewPatientLoyaltyCard(this.patientLoyaltyCard.patientId);
        this.onCloseCreateBonusCardModal();
      };
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      this
        .$loyaltySystemGateway
        .createPatientBonusCard(this.patientLoyaltyCard)
        .then((either) => {
          either.fold(onFail, onSuccess);
        });
    },
    /**
     * @description Создать скидочную карту
     * @returns {void}
     */
    createDiscountCard() {
      const onSuccess = ({ title }) => {
        this.notifySuccess(title);
        this.viewPatientLoyaltyCard(this.patientLoyaltyCard.patientId);
        this.onCloseCreateDiscountCardModal();
      };
      const onFail = (error) => {
        this.inputErrors = error.allCauses();
        this.notifyFail(error.getTitle());
      };
      this
        .$loyaltySystemGateway
        .createPatientDiscountCard(this.patientLoyaltyCard)
        .then((either) => {
          either.fold(onFail, onSuccess);
        });
    },
  },
};
